import React, { useState } from "react";
import Button from "@material-ui/core/Button";

let interval;

const MonetizationButton = () => {
  const [started, setStarted] = useState(false);

  const startMonetization = () => {
    const randomGuid = "c7ff7da9-8a41-4660-98a8-ca4df0176fbe";

    const meta = document.querySelector('meta[name="monetization"]');
    const metaContent = meta.getAttribute("content");
    const resolvedEndpoint = metaContent.replace(/^\$/, "https://");

    const monetizationstartEvent = new CustomEvent("monetizationstart", {
      detail: {
        requestId: randomGuid,
        id: randomGuid,
        metaContent,
        resolvedEndpoint,
      },
    });

    const monetizationprogressEvent = new CustomEvent("monetizationprogress", {
      detail: {
        amount: "200000",
        assetCode: "USD",
        assetScale: 9,
      },
    });

    document.monetization.dispatchEvent(monetizationstartEvent);
    document.monetization.state = "started";
    document.monetization.dispatchEvent(monetizationprogressEvent);

    interval = setInterval(() => {
      document.monetization.dispatchEvent(monetizationprogressEvent);
    }, 2000);
  };

  const stopMonetization = () => {
    clearInterval(interval);
  };

  const toggleMonetization = () => {
    setStarted(!started);

    if (!started) {
      startMonetization();
    } else {
      stopMonetization();
    }
  };

  return !started ? (
    <Button
      variant="contained"
      color="primary"
      onClick={toggleMonetization}
      style={{ marginBottom: 40 }}
    >
      Start Monetization
    </Button>
  ) : (
    <Button
      variant="contained"
      color="secondary"
      onClick={toggleMonetization}
      style={{ marginBottom: 40 }}
    >
      Stop Monetization
    </Button>
  );
};

export default MonetizationButton;
